// ============================================
// APPLICATION - Tutoriales Hooks
// ============================================

import { useQuery } from '@tanstack/react-query';
import { tutorialesRepository } from '../../infrastructure/http/tutoriales.repository';
import { tutorialesKeys } from '../query-keys';

/**
 * Hook para obtener la lista de módulos de tutoriales
 */
export const useModulosTutoriales = () => {
  return useQuery({
    queryKey: tutorialesKeys.modulos,
    queryFn: () => tutorialesRepository.obtenerModulos(),
    gcTime: 30 * 60 * 1000, // Cache por 30 minutos
  });
};

/**
 * Hook para obtener el tutorial de un módulo específico
 * @param moduleName - Nombre del módulo
 * @param enabled - Si la query debe ejecutarse
 */
export const useTutorialModulo = (moduleName: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: tutorialesKeys.modulo(moduleName),
    queryFn: () => tutorialesRepository.obtenerTutorialPorModulo(moduleName),
    enabled: enabled && !!moduleName,
    gcTime: 30 * 60 * 1000, // Cache por 30 minutos
  });
};
